import { workspaceDate } from '../../supabase/functions/_shared/standupDate'

// Activity is stored by workspace calendar date, not by browser-local midnight.
export function connectorDateRange(days: number | null, timezone: string | null | undefined, now = new Date()) {
  const to = workspaceDate(timezone, now)
  if (days === null) return { from: null, to }
  const start = new Date(`${to}T00:00:00Z`)
  start.setUTCDate(start.getUTCDate() - (days - 1))
  return { from: start.toISOString().slice(0, 10), to }
}
